import { getUser } from 'services/local/auth';
import type { LocalStorageFunctions, LocalSummaryOrder } from './types';
import { DEFAULT_ITEMS } from 'constants/summaryOrder';

const SUMMARY_ORDER: string = 'summary-order';

const getLocalStorageSummaryOrder = (fn: LocalStorageFunctions) => () => {
  const user = getUser(fn)();
  if (!user) return DEFAULT_ITEMS;
  const choice = fn.readObject<Record<string, string[]>>(SUMMARY_ORDER);
  if (!choice?.[user.user.email]) return DEFAULT_ITEMS;
  return choice[user.user.email];
};

const setLocalStorageSummaryOrder = (fn: LocalStorageFunctions) => (data: string[]) => {
  const user = getUser(fn)();
  if (!user) return;
  let choice = fn.readObject<Record<string, string[]>>(SUMMARY_ORDER);
  if (!choice) {
    choice = {};
  }
  choice[user.user.email] = data;
  fn.writeObject(SUMMARY_ORDER, choice);
};

const delLocalStorageSummaryOrder = (fn: LocalStorageFunctions) => () => {
  const user = getUser(fn)();
  if (!user) return;
  const choice = fn.readObject<Record<string, string[]>>(SUMMARY_ORDER);
  if (!choice?.[user.user.email]) return;
  delete choice[user.user.email];
  fn.writeObject(SUMMARY_ORDER, choice);
};

const summaryOrder = (fn: LocalStorageFunctions): LocalSummaryOrder => ({
  getLocalStorageSummaryOrder: getLocalStorageSummaryOrder(fn),
  setLocalStorageSummaryOrder: setLocalStorageSummaryOrder(fn),
  delLocalStorageSummaryOrder: delLocalStorageSummaryOrder(fn)
});

export default summaryOrder;
